import Base from 'app/views/base';

import tmpl from 'templates/carrier_type_list';
import CarrierTypeListItemView from 'app/views/carrier_type_list_item_view';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize(options) {
    this.carrierAccounts = options.carrierAccounts;
    this.listenTo(this.collection, 'sync', this.render);
    this.listenTo(this.collection, 'filtered', this.render);
  },

  beforeRender() {
    this.removeSubviews();

    this.collection.filtered().forEach(type => (
      this.addSubview(`ct_${type.get('type')}`, `#ct_${type.get('type')}`, new CarrierTypeListItemView({
        model: type,
        carrierAccounts: this.carrierAccounts,
      }))
    ));
  },

  context() {
    return { carrier_types: this.collection.filtered() };
  },
});



// WEBPACK FOOTER //
// ./app/views/carrier_type_list_view.js